import React from 'react';

import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import Chip from '@mui/joy/Chip';

import { NavItemLinkProps } from './NavToggleGroup';
import { getIcon } from '../../../icons';

function _getIcon(to: string) {
  return getIcon(to) || <PersonRoundedIcon />;
}

function _getLink(to: string, id: string) {
  switch (to) {
    case 'cash':
      return `https://${to}.app/$${id}`;
    case 'mail':
      return `mailto:${id}`;
    case 'messenger':
      return `https://m.me/${id}`;
    case 'paypal':
      return `https://${to}.me/${id}`;
    case 'snapchat':
      return `https://${to}.com/add/${id}`;
    case 'tiktok':
    case 'youtube':
      return `https://${to}.com/@${id}`;
    default:
      return `https://${to}.com/${id}`;
  }
}

function Social(props: NavItemLinkProps<any>) {
  const { children, className, icon, id, to, label, href } = props;
  const link = href || _getLink(to, id!);
  return (
    <Chip
      component="a"
      size="lg"
      color="primary"
      variant="solid"
      className={className || to}
      startDecorator={icon || _getIcon(to)}
      href={link}
      onClick={() => {}}
    >
      {label || id}
    </Chip>
  );
}

export default React.memo(Social);
